var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"cursor":"help"}},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},'v-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }